import { createSlice, configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import loginInfoReducer from "./LoginInfoSlice";
import errorInfoReducer from "./ErrorInfoSlice";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';


const reducers = combineReducers({
  loginInfo: loginInfoReducer,
  errorInfo: errorInfoReducer,
})

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ["errorInfo"]
}

const persistedReducer = persistReducer(persistConfig, reducers);//reducers)
//const store = createStore(persistedReducer);

// create store 
// const store = configureStore({
//   reducer: {
//     loginInfo: loginInfo.reducer
//   }
// })
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"]//[FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        //ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]//[FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
  /*reducer: persistedReducer,*/
  //devTools: process.env.NODE_ENV !== 'production',
  /*middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: false
    })
  }*/
})

//store.subscribe(render);

/*function render() {
  // 3.1) Get the current store state
  const state = store.getState()
  //console.log("STATE");
  //console.log(state);
  // 3.2) Extract the data you want
  //const newValue = state.value.toString()

  // 3.3) Update the UI with the new value
  //valueEl.innerHTML = newValue
}

render()*/


//export default store;

export const persistor = persistStore(store);